// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Skeleton Animation */
.skeleton-pulse {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

/* Specific Element Skeletons */
.skeleton-image {
    width: 100%;
    display: block;
    background-color: #ddd;
}

.skeleton-text {
    height: 16px;
    margin-bottom: 8px;
    background-color: #ddd;
    border-radius: 4px;
}

.skeleton-title {
    height: 20px;
    margin-bottom: 6px;
    width: 80%;
}

.skeleton-label {
    height: 12px;
    width: 60%;
    margin-bottom: 6px;
}

.skeleton-value {
    height: 20px;
    width: 40%;
}

.skeleton-button {
    height: 35px;
    width: 120px;
    border-radius: 50px;
    margin-left: auto;
    /* For right alignment */
}

/* Layout Specific Overrides matching LiveDeals.jsx classes */
.lead-card.skeleton-card {
    border: 1px solid #eee;
    /* Light border for skeleton state */
}

.lead-image.skeleton-wrapper {
    background-color: transparent;
    overflow: hidden;
}

.lead-image.skeleton-wrapper .skeleton-image {
    height: 100%;
    border-radius: 9.73px;
}

.lead-2-image.skeleton-wrapper .skeleton-image {
    height: 100%;
    border-radius: 1.73px;
}

@media (max-width: 414px) {
    .lead-image.skeleton-wrapper {
        height: 170px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/skeleton/LiveDealsSkeleton.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,6DAA6D;AAC7D;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Base Skeleton Animation */\n.skeleton-pulse {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-loading 1.5s infinite;\n    border-radius: 4px;\n}\n\n@keyframes skeleton-loading {\n    0% {\n        background-position: 200% 0;\n    }\n\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n/* Specific Element Skeletons */\n.skeleton-image {\n    width: 100%;\n    display: block;\n    background-color: #ddd;\n}\n\n.skeleton-text {\n    height: 16px;\n    margin-bottom: 8px;\n    background-color: #ddd;\n    border-radius: 4px;\n}\n\n.skeleton-title {\n    height: 20px;\n    margin-bottom: 6px;\n    width: 80%;\n}\n\n.skeleton-label {\n    height: 12px;\n    width: 60%;\n    margin-bottom: 6px;\n}\n\n.skeleton-value {\n    height: 20px;\n    width: 40%;\n}\n\n.skeleton-button {\n    height: 35px;\n    width: 120px;\n    border-radius: 50px;\n    margin-left: auto;\n    /* For right alignment */\n}\n\n/* Layout Specific Overrides matching LiveDeals.jsx classes */\n.lead-card.skeleton-card {\n    border: 1px solid #eee;\n    /* Light border for skeleton state */\n}\n\n.lead-image.skeleton-wrapper {\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.lead-image.skeleton-wrapper .skeleton-image {\n    height: 100%;\n    border-radius: 9.73px;\n}\n\n.lead-2-image.skeleton-wrapper .skeleton-image {\n    height: 100%;\n    border-radius: 1.73px;\n}\n\n@media (max-width: 414px) {\n    .lead-image.skeleton-wrapper {\n        height: 170px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
